import { render, staticRenderFns } from "./OptionConfig.vue?vue&type=template&id=4cfe3962&scoped=true&"
import script from "./OptionConfig.vue?vue&type=script&lang=js&"
export * from "./OptionConfig.vue?vue&type=script&lang=js&"
import style0 from "./OptionConfig.vue?vue&type=style&index=0&id=4cfe3962&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cfe3962",
  null
  
)

export default component.exports